import { App } from 'vue'
import OptionsGroup from './LpOptionsGroup.vue'

OptionsGroup.install = (Vue: App) => {
  Vue.component(OptionsGroup.name, OptionsGroup)
}

export default OptionsGroup
